module.exports = __webpack_public_path__ + "common/logistics/icon-pgeon-c75a7169871bcb75052d332c5a513033.svg";